<template style="padding-left:100px;" id="resetpass">
    <div class="cpassword-container">
            <div class="d-flex w-100 m-auto p-3 justify-content-center flex-column cpassword">
                <h2>Reset Password</h2><hr>
                <!--Alert Message-->
                <span v-bind:class="{ is_valid : contains_eight_characters, is_not_valid: !contains_eight_characters }">Min 8 Characters</span>
                <span v-bind:class="{ is_valid: contains_number, is_not_valid: !contains_number }">Contains Number</span>
                <span v-bind:class="{ is_valid: contains_uppercase, is_not_valid: !contains_uppercase }">Contains Uppercase</span>
                <span v-bind:class="{ is_valid: contains_special_character, is_not_valid: !contains_special_character }">Contains Special Character</span>

                <div class="alert alert-danger" v-if="checkingConfirmPass">New password and confirm password did not match.</div>
                <!-- <div v-bind:style="{color:msgColor }" v-else>{{updateMsg}}</div> --><br/><br/>

                <form action="#" method="post">
                    <label class="float-left">*Select User: </label>
                    <select v-model="userName" class="float-left">
                        <option v-for="ov in userData" :key="ov.userId">{{ov.userName}}</option>
                    </select> <br/><br/>
                    <div class="form-group">
                        <label class="float-left">New Password</label>
                        <input type="password" @input="checkPassword" class="form-control"
                               id="" aria-describedby="emailHelp"
                               v-model="newPassword"
                               ref="newPassword"
                               required
                               placeholder="*New password" :disabled='userName==null'>
                    </div>
                    <div class="form-group">
                        <label class="float-left">Confirm New Password</label>
                        <input type="password" @input="confirmPassword" class="form-control"
                               id="" aria-describedby="emailHelp"
                               v-model="confirmPass"
                               ref="confirmPass"
                               required
                               placeholder="*Confirm new password" :disabled='userName==null'>
                    </div>
                    <button type="reset" class="btn btn-primary mr-3">Cancel</button>
                    <button type="button" v-on:click="resetPassword()" class="btn btn-primary ml-3" :disabled='isDisabled'>Reset Password</button>
                </form>
            </div>
        </div>
</template>
<script>
import axios from 'axios'

export default {
    name: 'resetPass',
    data () {
      return {
        userName: null,
        userData: [],
        newPassword: null,
        confirmPass: null,
        resetPassFailed: false,
        checkingConfirmPass: false,
        /* password validation */
        password_length: 0,
        contains_eight_characters: false,
        contains_number: false,
        contains_uppercase: false,
        contains_special_character: false,
        valid_password: false,
        isDisabled: true,
        updateMsg: null,
        msgColor: null,
      }
    },

    created: function () {
        this.getAllUserList()
    },
    methods: {
         getAllUserList: function () {
            axios.get('/api/user').then((response) => {
                  this.userData= response.data
                  console.log("userData: ", this.userData)
            })
         },
         checkPassword() {
              this.password_length = this.newPassword.length;
              const format= /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/;

              if (this.password_length >= 8) {
                this.contains_eight_characters = true;
              } else {
                    this.contains_eight_characters = false;
              }
              this.contains_number = /\d/.test(this.newPassword);
              this.contains_uppercase = /[A-Z]/.test(this.newPassword);
              this.contains_special_character = format.test(this.newPassword);

              if (this.contains_eight_characters === true && this.contains_special_character === true &&
                  this.contains_uppercase === true && this.contains_number === true) {
                    this.valid_password = true;
              } else {
                    this.valid_password = false;
              }
         },
         confirmPassword: function () {
            if(this.newPassword=== this.confirmPass) {
                  this.checkingConfirmPass= false
                  if (this.valid_password === true && this.newPassword=== this.confirmPass)
                    this.isDisabled= false
            }
            else {
                this.checkingConfirmPass= true
                this.isDisabled= true
            }
            console.warn("confirm password: ", this.confirmPass)
         },
         resetPassword: function () {
            this.resetPassFailed = false
            this.$store.state.authRequired = false
            var formData = {
                userName: this.userName,
                newPassword: this.newPassword
            };

            axios.post(`/auth/reset-password`, formData).then((response) => {
                console.log("this.data: ", response.data)
                this.msgColor= 'green'
                console.log("Password updated successfully.")
                alert(this.updateMsg= 'Password updated successfully.')
                this.isDisabled= true
            }, error => {
                  alert(this.updateMsg= error.response && error.response.data ? error.response.data.title : '')
                  this.msgColor= 'red'
                  this.errorTitle = error.response && error.response.data ? error.response.data.title : ''
                  this.$store.commit('authError')
                  this.resetPassFailed = !this.$store.state.serverIsDown
            })
      }
    }
  }
</script>
<style scoped>
    .cpassword-container {
        display: flex;
        width: 100vh;
        height: 75vh;
        justify-content: center;
        align-content: center;
        align-items: center;
        align-self: center;
        padding-top: 50px;
    }

    .cpassword { box-shadow: 1px 2px 2px 3px #a7aeaa; }
    .btn.btn[disabled] { color: black; }
    .is_valid { color: green }
    .is_not_valid { color: red }
</style>